import { render } from "./security.vue?vue&type=template&id=90a42d6a"
import script from "./security.vue?vue&type=script&lants=ts&lang=js"
export * from "./security.vue?vue&type=script&lants=ts&lang=js"
script.render = render

export default script